const LangEgiftHeaderMegaMenuLink = {
	"mm.Link.coffee.OurCoffees": [
		"https://en.starbucks.vn/coffee/our-coffees",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/c%C3%A0-ph%C3%AA-c%E1%BB%A7a-ch%C3%BAng-t%C3%B4i",
	],
	"mm.Link.coffee.OurCoffees.WholeBeanCoffee": [
		"https://en.starbucks.vn/coffee/our-coffees/format/whole-bean",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/c%C3%A0-ph%C3%AA-c%E1%BB%A7a-ch%C3%BAng-t%C3%B4i/format/whole-bean",
	],
	"mm.Link.coffee.OurCoffees.ViewAllCoffees": [
		"https://en.starbucks.vn/coffee/our-coffees/view-all-coffees",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/c%C3%A0-ph%C3%AA-c%E1%BB%A7a-ch%C3%BAng-t%C3%B4i/view-all-coffees",
	],
	//
	"mm.Link.coffee.FindYourPerfectCoffee": [
		"https://en.starbucks.vn/coffee/finder",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/t%C3%ACm-lo%E1%BA%A1i-c%C3%A0-ph%C3%AA-ho%C3%A0n-h%E1%BA%A3o-c%E1%BB%A7a-b%E1%BA%A1n",
	],
	//
	"mm.Link.coffee.Espresso": [
		"https://en.starbucks.vn/coffee/espresso",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/espresso",
	],
	"mm.Link.coffee.Espresso.TheIngredients": [
		"https://en.starbucks.vn/coffee/espresso/ingredients",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/espresso/th%C3%A0nh-ph%E1%BA%A7n",
	],
	"mm.Link.coffee.Espresso.TheBestEquipment": [
		"https://en.starbucks.vn/coffee/espresso/best-equipment",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/espresso/thi%E1%BA%BFt-b%E1%BB%8B-t%E1%BB%91t-nh%E1%BA%A5t",
	],
	"mm.Link.coffee.Espresso.WhoMakesIt": [
		"https://en.starbucks.vn/coffee/espresso/who-makes-it",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/espresso/nh%C3%A2n-vi%C3%AAn-pha-ch%E1%BA%BF-c%C3%A0-ph%C3%AA",
	],
	//
	"mm.Link.coffee.HowToBrewGreatCoffee": [
		"https://en.starbucks.vn/coffee/how-to-brew",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/l%C3%A0m-th%E1%BA%BF-n%C3%A0o-%C4%91%E1%BB%83-n%E1%BA%A5u",
	],
	"mm.Link.coffee.HowToBrewGreatCoffee.CoffeePress": [
		"https://en.starbucks.vn/coffee/how-to-brew/coffee-press",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/l%C3%A0m-th%E1%BA%BF-n%C3%A0o-%C4%91%E1%BB%83-n%E1%BA%A5u/b%C3%A1o-ch%C3%AD-c%C3%A0-ph%C3%AA",
	],
	"mm.Link.coffee.HowToBrewGreatCoffee.PourOver": [
		"https://en.starbucks.vn/coffee/how-to-brew/pour-over",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/l%C3%A0m-th%E1%BA%BF-n%C3%A0o-%C4%91%E1%BB%83-n%E1%BA%A5u/%C4%91%E1%BB%95-giao",
	],
	"mm.Link.coffee.HowToBrewGreatCoffee.IcedPourOver": [
		"https://en.starbucks.vn/coffee/how-to-brew/iced-pour-over",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/l%C3%A0m-th%E1%BA%BF-n%C3%A0o-%C4%91%E1%BB%83-n%E1%BA%A5u/%C4%91%C3%A1-%C4%91%E1%BB%95-giao",
	],
	"mm.Link.coffee.HowToBrewGreatCoffee.CoffeeBrewer": [
		"https://en.starbucks.vn/coffee/how-to-brew/coffee-brewer",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/l%C3%A0m-th%E1%BA%BF-n%C3%A0o-%C4%91%E1%BB%83-n%E1%BA%A5u/bia-c%C3%A0-ph%C3%AA",
	],
	//
	"mm.Link.coffee.EthicalSourcing": [
		"https://en.starbucks.vn/coffee/ethical-sourcing",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/t%C3%ACm-ngu%E1%BB%93n-cung-%E1%BB%A9ng-c%C3%B3-%C4%91%E1%BA%A1o-%C4%91%E1%BB%A9c",
	],
	"mm.Link.coffee.EthicalSourcing.Coffee": [
		"https://en.starbucks.vn/responsibility/ethical-sourcing/coffee-sourcing",
		"https://www.starbucks.vn/tr%C3%A1ch-nhi%E1%BB%87m/t%C3%ACm-ngu%E1%BB%93n-cung-%E1%BB%A9ng-c%C3%B3-%C4%91%E1%BA%A1o-%C4%91%E1%BB%A9c/t%C3%ACm-ngu%E1%BB%93n-cung-%E1%BB%A9ng-c%C3%A0-ph%C3%AA",
	],
	"mm.Link.coffee.EthicalSourcing.CoffeeQuality": [
		"https://en.starbucks.vn/coffee/ethical-sourcing/coffee-quality",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/t%C3%ACm-ngu%E1%BB%93n-cung-%E1%BB%A9ng-c%C3%B3-%C4%91%E1%BA%A1o-%C4%91%E1%BB%A9c/ch%E1%BA%A5t-l%C6%B0%E1%BB%A3ng-c%C3%A0-ph%C3%AA",
	],
	"mm.Link.coffee.EthicalSourcing.FarmerSupport": [
		"https://en.starbucks.vn/responsibility/ethical-sourcing/farmer-support",
		"https://www.starbucks.vn/tr%C3%A1ch-nhi%E1%BB%87m/t%C3%ACm-ngu%E1%BB%93n-cung-%E1%BB%A9ng-c%C3%B3-%C4%91%E1%BA%A1o-%C4%91%E1%BB%A9c/h%E1%BB%97-tr%E1%BB%A3-n%C3%B4ng-d%C3%A2n",
	],
	//
	"mm.Link.coffee.LearnMore.StarbucksRoastSpectrum": [
		"https://en.starbucks.vn/coffee/learn/roast",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/learn/d%C3%B2ng-s%E1%BA%A3n-ph%E1%BA%A9m-c%C3%A0-ph%C3%AA-rang",
	],
	"mm.Link.coffee.LearnMore.FlavorsInYourCup": [
		"https://en.starbucks.vn/coffee/learn/flavors-in-your-cup",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/learn/nh%E1%BB%AFng-h%C6%B0%C6%A1ng-v%E1%BB%8B-trong-c%E1%BB%91c-c%C3%A0-ph%C3%AA-c%E1%BB%A7a-b%E1%BA%A1n",
	],
	"mm.Link.coffee.LearnMore.CoffeeFAQ": [
		"https://en.starbucks.vn/coffee/learn/coffee-faqs",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/learn/c%C3%A2u-h%E1%BB%8Fi-th%C6%B0%E1%BB%9Dng-g%E1%BA%B7p-v%E1%BB%81-c%C3%A0-ph%C3%AA",
	],
	//
	"mm.Link.coffee.LookingForCoffeeBeverages.Drinks": [
		"en.starbucks.vn/menu-list/beverage-list/",
		"https://www.starbucks.vn/th%E1%BB%B1c-%C4%91%C6%A1n/th%E1%BB%A9c-u%E1%BB%91ng/",
	],
	//
	"mm.Link.coffee.side": [
		"en.starbucks.vn/coffee/blonde",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/v%C3%A0ng",
	],
	//
	//
	"mm.Link.menu.Drinks": [
		"https://en.starbucks.vn/menu-list/beverage-list",
		"https://www.starbucks.vn/th%E1%BB%B1c-%C4%91%C6%A1n/th%E1%BB%A9c-u%E1%BB%91ng",
	],
	"mm.Link.menu.Drinks.EspressoBeverages": [
		"https://en.starbucks.vn/menu-list/beverage-list/espresso-beverages",
		"https://www.starbucks.vn/th%E1%BB%B1c-%C4%91%C6%A1n/th%E1%BB%A9c-u%E1%BB%91ng/th%E1%BB%A9c-u%E1%BB%91ng-espresso",
	],
	"mm.Link.menu.Drinks.ChocolateBeverages": [
		"https://en.starbucks.vn/menu-list/beverage-list/chocolate-beverages",
		"https://www.starbucks.vn/th%E1%BB%B1c-%C4%91%C6%A1n/th%E1%BB%A9c-u%E1%BB%91ng/th%E1%BB%A9c-u%E1%BB%91ng-v%E1%BB%9Bi-s%C3%B4c%C3%B4la",
	],
	"mm.Link.menu.Drinks.FrappuccinoBlendedCoffee": [
		"https://en.starbucks.vn/menu-list/beverage-list/frappuccino-blended-coffee",
		"https://www.starbucks.vn/th%E1%BB%B1c-%C4%91%C6%A1n/th%E1%BB%A9c-u%E1%BB%91ng/c%C3%A0-ph%C3%AA-xay-frappuccino",
	],
	"mm.Link.menu.Drinks.FrappuccinoBlendedCream": [
		"https://en.starbucks.vn/menu-list/beverage-list/frappuccino-blended-cream",
		"https://www.starbucks.vn/th%E1%BB%B1c-%C4%91%C6%A1n/th%E1%BB%A9c-u%E1%BB%91ng/kem-tr%E1%BB%99n-frappuccino",
	],
	"mm.Link.menu.Drinks.BrewedTea": [
		"https://en.starbucks.vn/menu-list/beverage-list/brewed-tea",
		"https://www.starbucks.vn/th%E1%BB%B1c-%C4%91%C6%A1n/th%E1%BB%A9c-u%E1%BB%91ng/tr%C3%A0-pha",
	],
	//
	"mm.Link.menu.Food": [
		"https://en.starbucks.vn/menu-list/food-list",
		"https://www.starbucks.vn/th%E1%BB%B1c-%C4%91%C6%A1n/th%E1%BB%A9c-%C4%83n",
	],
	"mm.Link.menu.Food.Bakery": [
		"https://en.starbucks.vn/menu-list/food-list/bakery",
		"https://www.starbucks.vn/th%E1%BB%B1c-%C4%91%C6%A1n/th%E1%BB%A9c-%C4%83n/b%C3%A1nh",
	],
	"mm.Link.menu.Food.Muffins": [
		"https://en.starbucks.vn/menu-list/food-list/muffins",
		"https://www.starbucks.vn/th%E1%BB%B1c-%C4%91%C6%A1n/th%E1%BB%A9c-%C4%83n/b%C3%A1nh-muffin",
	],
	"mm.Link.menu.Food.Cookies": [
		"https://en.starbucks.vn/menu-list/food-list/cookies",
		"https://www.starbucks.vn/th%E1%BB%B1c-%C4%91%C6%A1n/th%E1%BB%A9c-%C4%83n/b%C3%A1nh-cookie",
	],
	"mm.Link.menu.Food.Cakes": [
		"https://en.starbucks.vn/menu-list/food-list/cakes",
		"https://www.starbucks.vn/th%E1%BB%B1c-%C4%91%C6%A1n/th%E1%BB%A9c-%C4%83n/b%C3%A1nh-ng%E1%BB%8Dt",
	],
	"mm.Link.menu.Food.ColdSandwiches": [
		"https://en.starbucks.vn/menu-list/food-list/cold-sandwiches",
		"https://www.starbucks.vn/th%E1%BB%B1c-%C4%91%C6%A1n/th%E1%BB%A9c-%C4%83n/b%C3%A1nh-m%C3%AC-sandwiches",
	],
	//
	"mm.Link.menu.LearnAboutTheStarbucksRoastSpectrum": [
		"https://en.starbucks.vn/coffee/learn/roast",
		"https://www.starbucks.vn/c%C3%A0-ph%C3%AA/learn/d%C3%B2ng-s%E1%BA%A3n-ph%E1%BA%A9m-c%C3%A0-ph%C3%AA-rang",
	],
	//
	"mm.Link.menu.side": [
		"https://en.starbucks.vn/menu-list/food-list",
		"https://www.starbucks.vn/th%E1%BB%B1c-%C4%91%C6%A1n/th%E1%BB%A9c-%C4%83n/",
	],
	//
	//
	"mm.Link.coffeehouse.CoffeemasterProgram": [
		"https://en.starbucks.vn/coffeehouse/coffeemaster-program",
		"https://www.starbucks.vn/qu%C3%A1n-c%C3%A0-ph%C3%AA/ch%C6%B0%C6%A1ng-tr%C3%ACnh-chuy%C3%AAn-gia-c%C3%A0-ph%C3%AA",
	],
	"mm.Link.coffeehouse.OnlineCommunity": [
		"https://en.starbucks.vn/coffeehouse/online-community",
		"https://www.starbucks.vn/qu%C3%A1n-c%C3%A0-ph%C3%AA/c%E1%BB%99ng-%C4%91%E1%BB%93ng-tr%E1%BB%B1c-tuy%E1%BA%BFn",
	],
	"mm.Link.coffeehouse.StoreDesign": [
		"https://en.starbucks.vn/coffeehouse/store-design",
		"https://www.starbucks.vn/qu%C3%A1n-c%C3%A0-ph%C3%AA/thi%E1%BA%BFt-k%E1%BA%BF-c%E1%BB%ADa-h%C3%A0ng",
	],
	"mm.Link.coffeehouse.Merchandise": [
		"https://en.starbucks.vn/coffeehouse/merchandise",
		"https://www.starbucks.vn/qu%C3%A1n-c%C3%A0-ph%C3%AA/th%C6%B0%C6%A1ng-m%E1%BA%A1i",
	],
	"mm.Link.coffeehouse.Merchandise.Drinkware": [
		"https://en.starbucks.vn/coffeehouse/merchandise/drinkware",
		"https://www.starbucks.vn/qu%C3%A1n-c%C3%A0-ph%C3%AA/th%C6%B0%C6%A1ng-m%E1%BA%A1i/drinkware",
	],
	"mm.Link.coffeehouse.Merchandise.Machines": [
		"https://en.starbucks.vn/coffeehouse/merchandise/machines",
		"https://www.starbucks.vn/qu%C3%A1n-c%C3%A0-ph%C3%AA/th%C6%B0%C6%A1ng-m%E1%BA%A1i/machines",
	],
	"mm.Link.coffeehouse.Merchandise.Accessories": [
		"https://en.starbucks.vn/coffeehouse/merchandise/accessories",
		"https://www.starbucks.vn/qu%C3%A1n-c%C3%A0-ph%C3%AA/th%C6%B0%C6%A1ng-m%E1%BA%A1i/accessories",
	],
	//
	"mm.Link.coffeehouse.Drinks": [
		"https://en.starbucks.vn/menu-list/beverage-list/",
		"https://www.starbucks.vn/th%E1%BB%B1c-%C4%91%C6%A1n/th%E1%BB%A9c-u%E1%BB%91ng/",
	],
	"mm.Link.coffeehouse.AboutUs": [
		"https://en.starbucks.vn/about-us/",
		"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/",
	],
	//
	"mm.Link.coffeehouse.side": [
		"https://en.starbucks.vn/coffeehouse/",
		"https://www.starbucks.vn/qu%C3%A1n-c%C3%A0-ph%C3%AA/",
	],
	//
	//
	"mm.Link.responsibility.EthicalSourcing": [
		"https://en.starbucks.vn/responsibility/ethical-sourcing",
		"https://www.starbucks.vn/tr%C3%A1ch-nhi%E1%BB%87m/t%C3%ACm-ngu%E1%BB%93n-cung-%E1%BB%A9ng-c%C3%B3-%C4%91%E1%BA%A1o-%C4%91%E1%BB%A9c",
	],
	"mm.Link.responsibility.EthicalSourcing.CoffeeSourcing": [
		"https://en.starbucks.vn/responsibility/ethical-sourcing/coffee-sourcing",
		"https://www.starbucks.vn/tr%C3%A1ch-nhi%E1%BB%87m/t%C3%ACm-ngu%E1%BB%93n-cung-%E1%BB%A9ng-c%C3%B3-%C4%91%E1%BA%A1o-%C4%91%E1%BB%A9c/h%E1%BB%97-tr%E1%BB%A3-n%C3%B4ng-d%C3%A2n",
	],
	"mm.Link.responsibility.EthicalSourcing.FarmerSupport": [
		"https://en.starbucks.vn/responsibility/ethical-sourcing/farmer-support",
		"https://www.starbucks.vn/tr%C3%A1ch-nhi%E1%BB%87m/t%C3%ACm-ngu%E1%BB%93n-cung-%E1%BB%A9ng-c%C3%B3-%C4%91%E1%BA%A1o-%C4%91%E1%BB%A9c/t%C3%ACm-ngu%E1%BB%93n-cung-%E1%BB%A9ng-c%C3%A0-ph%C3%AA",
	],
	"mm.Link.responsibility.EthicalSourcing.TeaSourcing": [
		"https://en.starbucks.vn/responsibility/ethical-sourcing/tea-sourcing",
		"https://www.starbucks.vn/tr%C3%A1ch-nhi%E1%BB%87m/t%C3%ACm-ngu%E1%BB%93n-cung-%E1%BB%A9ng-c%C3%B3-%C4%91%E1%BA%A1o-%C4%91%E1%BB%A9c/t%C3%ACm-ngu%E1%BB%93n-cung-%E1%BB%A9ng-tr%C3%A0",
	],
	"mm.Link.responsibility.EthicalSourcing.CocoaSourcing": [
		"https://en.starbucks.vn/responsibility/ethical-sourcing/cocoa-sourcing",
		"https://www.starbucks.vn/tr%C3%A1ch-nhi%E1%BB%87m/t%C3%ACm-ngu%E1%BB%93n-cung-%E1%BB%A9ng-c%C3%B3-%C4%91%E1%BA%A1o-%C4%91%E1%BB%A9c/t%C3%ACm-ngu%E1%BB%93n-cung-%E1%BB%A9ng-ca-cao",
	],
	//
	"mm.Link.responsibility.Environment": [
		"https://en.starbucks.vn/responsibility/environment",
		"https://www.starbucks.vn/tr%C3%A1ch-nhi%E1%BB%87m/m%C3%B4i-tr%C6%B0%E1%BB%9Dng",
	],
	"mm.Link.responsibility.Environment.Recycling": [
		"https://en.starbucks.vn/responsibility/environment/recycling",
		"https://www.starbucks.vn/tr%C3%A1ch-nhi%E1%BB%87m/m%C3%B4i-tr%C6%B0%E1%BB%9Dng/t%C3%A1i-ch%E1%BA%BF",
	],
	"mm.Link.responsibility.Environment.Energy": [
		"https://en.starbucks.vn/responsibility/environment/energy",
		"https://www.starbucks.vn/tr%C3%A1ch-nhi%E1%BB%87m/m%C3%B4i-tr%C6%B0%E1%BB%9Dng/n%C4%83ng-l%C6%B0%E1%BB%A3ng",
	],
	"mm.Link.responsibility.Environment.Water": [
		"https://en.starbucks.vn/responsibility/environment/water",
		"https://www.starbucks.vn/tr%C3%A1ch-nhi%E1%BB%87m/m%C3%B4i-tr%C6%B0%E1%BB%9Dng/n%C6%B0%E1%BB%9Bc",
	],
	"mm.Link.responsibility.Environment.GreenBuilding": [
		"https://en.starbucks.vn/responsibility/environment/green-building",
		"https://www.starbucks.vn/tr%C3%A1ch-nhi%E1%BB%87m/m%C3%B4i-tr%C6%B0%E1%BB%9Dng/c%C3%B4ng-tr%C3%ACnh-xanh",
	],
	"mm.Link.responsibility.Environment.ClimateChange": [
		"https://en.starbucks.vn/responsibility/environment/climate-change",
		"https://www.starbucks.vn/tr%C3%A1ch-nhi%E1%BB%87m/m%C3%B4i-tr%C6%B0%E1%BB%9Dng/bi%E1%BA%BFn-%C4%91%E1%BB%95i-kh%C3%AD-h%E1%BA%ADu",
	],
	//
	"mm.Link.responsibility.AboutUs": [
		"https://en.starbucks.vn/about-us/",
		"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/",
	],
	//
	//
	"mm.Link.aboutus.OurHeritage": [
		"https://en.starbucks.vn/about-us/our-heritage",
		"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/di-s%E1%BA%A3n",
	],
	"mm.Link.aboutus.OurCompany": [
		"https://en.starbucks.vn/about-us/company-information",
		"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty",
	],
	"mm.Link.aboutus.OurCompany.MissionStatement": [
		"https://en.starbucks.vn/about-us/company-information/mission-statement",
		"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/tuy%C3%AAn-b%E1%BB%91-v%E1%BB%81-s%E1%BB%A9-m%E1%BB%87nh",
	],
	"mm.Link.aboutus.OurCompany.BusinessEthicsAndCompliance": [
		"https://en.starbucks.vn/about-us/company-information/business-ethics-and-compliance",
		"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/%C4%91%E1%BA%A1o-%C4%91%E1%BB%A9c-v%C3%A0-tu%C3%A2n-th%E1%BB%A7-trong-kinh-doanh",
	],
	"mm.Link.aboutus.OurCompany.DiversityAtStarbucks": [
		"https://en.starbucks.vn/about-us/company-information/diversity-at-starbucks",
		"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/s%E1%BB%B1-%C4%91a-d%E1%BA%A1ng-t%E1%BA%A1i-starbucks",
	],
	"mm.Link.aboutus.OurCompany.OnlinePolicies": [
		"https://en.starbucks.vn/about-us/company-information/online-policies",
		"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/ch%C3%ADnh-s%C3%A1ch-tr%E1%BB%B1c-tuy%E1%BA%BFn",
	],
	//
	"mm.Link.aboutus.CareerCenter": [
		"https://en.starbucks.vn/about-us/career-center",
		"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C6%A1-h%E1%BB%99i-ngh%E1%BB%81-nghi%E1%BB%87p",
	],
	//
	"mm.Link.aboutus.CustomerService": [
		"https://en.starbucks.vn/customer-service/",
		"https://www.starbucks.vn/d%E1%BB%8Bch-v%E1%BB%A5-kh%C3%A1ch-h%C3%A0ng/",
	],
	"mm.Link.aboutus.StoreLocator": [
		"http://en.starbucks.vn/store-locator",
		"https://www.starbucks.vn:443/b%E1%BB%99-%C4%91%E1%BB%8Bnh-v%E1%BB%8B-c%E1%BB%ADa-h%C3%A0ng",
	],
	//
	"mm.Link.aboutus.side": [
		"https://en.starbucks.vn/about-us/our-heritage/",
		"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/di-s%E1%BA%A3n/",
	],
	//
	//
	"mm.Link.card.LearnMore.ProgramTermsAndConditions": [
		"https://en.starbucks.vn/about-us/company-information/online-policies/starbucks-rewards-terms-and-conditions",
		"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/ch%C3%ADnh-s%C3%A1ch-tr%E1%BB%B1c-tuy%E1%BA%BFn/starbucks-rewards-terms-and-conditions",
	],
	"mm.Link.card.LearnMore.PrivacyStatement": [
		"https://en.starbucks.vn/about-us/company-information/online-policies/privacy-statement",
		"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/ch%C3%ADnh-s%C3%A1ch-tr%E1%BB%B1c-tuy%E1%BA%BFn/chi-nh-sa-ch-ba-o-m%C3%A2-t-th%C3%B4ng-tin",
	],
	"mm.Link.card.LearnMore.CardFaqs": [
		"https://en.starbucks.vn/about-us/company-information/online-policies/starbucks-rewards-faqs",
		"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/ch%C3%ADnh-s%C3%A1ch-tr%E1%BB%B1c-tuy%E1%BA%BFn/starbucks-rewards-faqs",
	],
	//
	"mm.Link.card.StoreLocator": [
		"http://en.starbucks.vn/store-locator",
		"https://www.starbucks.vn:443/b%E1%BB%99-%C4%91%E1%BB%8Bnh-v%E1%BB%8B-c%E1%BB%ADa-h%C3%A0ng",
	],
}

export default LangEgiftHeaderMegaMenuLink



// WEBPACK FOOTER //
// ./src/resources/modules/LangEgiftHeaderMegaMenuLink.js